import React from 'react';
import { Flex, Icon, SpinnerOutlined } from '../..';
import { Typography } from '../../Typography';
export var Loading = function Loading(_ref) {
  var loadingText = _ref.loadingText;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    px: "s",
    py: "xxs",
    "data-test": "select-loading",
    justifyContent: !loadingText ? 'center' : undefined
  }, /*#__PURE__*/React.createElement(Icon, {
    spin: true,
    component: SpinnerOutlined,
    color: "primary.base",
    size: "16px"
  }), /*#__PURE__*/React.createElement(Typography, {
    ml: "xxs",
    variant: "body2"
  }, loadingText));
};